module.exports = __webpack_public_path__ + "static/media/play.0bd496b1.svg";